import React, { useState, useEffect, useRef } from 'react'
import "../../styles/componentsStyles/Chat/ChattingArea.scss"

import Send from "../../assets/icons/send.svg"

const ChattingArea = () => {
    const [chat, setChat] = useState({ message: "" });
    const textareaRef = useRef(null);
    const [height, setHeight] = useState(0);

    useEffect(() => {
        updateHeight();
    }, [textareaRef.current?.scrollHeight, textareaRef.current?.value]);

    const updateHeight = () => {
        if (textareaRef.current) {
            const newHeight = textareaRef.current.scrollHeight + 2;
            textareaRef.current.style.height = `${textareaRef.current.scrollHeight}px`;
            setHeight(newHeight);
        }
    };

    return (
        <div className='chatting-area'>
            <div className="chatting-area__old-chats">

            </div>
            <div className="chatting-area__input-container">
                <textarea style={{ height }} ref={textareaRef} className='chatting-area__input' value={chat.message}
                    onChange={(e) => { setChat({ ...chat, message: e.target.value }); updateHeight() }} onInput={updateHeight} type="text" placeholder='Message' />
                <button className='chatting-area__send-btn'><img src={Send} alt="send" /></button>
            </div>
        </div>
    )
}

export default ChattingArea